import { Avatar, isWeb, Stack, Text, XStack, YStack } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'
import { Button } from '../Button'
import { useCallback } from 'react'
import { LinearGradient } from 'expo-linear-gradient'
import { StyleSheet } from 'react-native'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import { router, usePathname } from 'expo-router'
import { openWebBrowser } from '@utils/openWebBrowser'
import { useDomain } from '@hooks/useThemeParams'
import { useSession } from '@hooks/useSession'

export function HeaderMobile({ openModal }: { openModal: () => void }) {
  const { user } = useSession()
  const { subdomainURL } = useDomain()
  const handleRouter = useCallback((path: string) => {
    router.navigate(path)
  }, [])

  const handleGoToMessages = useCallback(() => {
    openWebBrowser(`${subdomainURL}/channels`)
  }, [subdomainURL])

  return (
    <Stack paddingTop="$spacing-inset-xs">
      <LinearGradient
        colors={['transparent', 'rgba(0,0,0,0.76)']}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          height: 115,
        }}
      />
      <XStack
        marginHorizontal="$spacing-inset-xs"
        bg="$neutral-0"
        paddingTop="$spacing-inset-quarck"
        borderRadius="$border-radius-pill"
        paddingHorizontal="$spacing-inset-md"
        justifyContent="space-around"
        height={65}
      >
        <MobileButton
          label="INÍCIO"
          action={() => handleRouter('/')}
          icon="house"
          user={user}
        />
        {isWeb && (
          <MobileButton
            label="MENSAGENS"
            action={handleGoToMessages}
            icon="envelope"
            user={user}
          />
        )}

        <MobileButton
          label="PERFIL"
          avatar={user?.coverImageUrl}
          action={() => openModal()}
          icon="user"
          user={user}
        />
      </XStack>
    </Stack>
  )
}

interface IMobileButtonProps {
  icon: IconName
  label: string
  avatar?: string
  action: () => void
  user?: {
    firstName?: string
  } | null
}

export function MobileButton({
  icon,
  label,
  action,
  avatar,
  user,
}: IMobileButtonProps) {
  const pathname = usePathname()
  const isActive = pathname === '/' && label === 'INÍCIO'

  const hasAvatar =
    avatar !== null &&
    avatar !== undefined &&
    avatar !== 'https://cdn.edools.com/assets/images/users/default.jpeg'

  return (
    <Stack borderTopWidth={isActive ? 2 : 0} borderTopColor="$primary-300">
      <Button
        outline
        size="small"
        borderColor="transparent"
        outlineWidth={0}
        focusStyle={{ ...styles.unstyled }}
        pressStyle={{ ...styles.unstyled }}
        onPress={() => action()}
      >
        <YStack
          alignItems="center"
          flex={1}
          paddingTop="$spacing-inset-quarck"
          gap="$spacing-inset-quarck"
        >
          {avatar && icon === 'user' ? (
            <Avatar
              circular
              size={24}
              borderColor="$neutral-600"
              borderWidth={1}
            >
              {hasAvatar ? (
                <Avatar.Image src={avatar} />
              ) : (
                <Avatar.Fallback backgroundColor="$neutral-600">
                  <Text
                    color="$neutral-0"
                    fontSize="$font-size-xs"
                    textAlign="center"
                    fontWeight={700}
                  >
                    {user?.firstName?.[0]?.toUpperCase()}
                  </Text>
                </Avatar.Fallback>
              )}
            </Avatar>
          ) : (
            <HeroIcon
              icon={['fal', icon]}
              color={isActive ? '$primary-300' : '$neutral-800'}
              size={24}
            />
          )}
          <Text
            ff={isActive ? '$mulishBold' : '$mulishRegular'}
            color={isActive ? '$primary-300' : '$neutral-600'}
            fontSize="$font-size-xxxs"
            fontWeight={isActive ? 700 : 400}
          >
            {label}
          </Text>
        </YStack>
      </Button>
    </Stack>
  )
}

const styles = StyleSheet.create({
  unstyled: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    borderWidth: 0,
  },
})
